

<div class="section-full p-tb80 inner-page-padding">
  <!-- LOCATION BLOCK-->
  <div class="container">

      <!-- GOOGLE MAP & CONTACT FORM -->
      <div class="section-content">
          <!-- CONTACT FORM-->
          <div class="row" *ngIf="evento?.estado_evento">
            <div class="col-md-12">
              <div class="text-center">
                <h1>
                  Rendición Pública de Cuentas<br>
                </h1>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">

                <form [formGroup]="form" (submit)="submit()">
                      <div class="contact-one m-b30">

                      <!-- TITLE START -->
                      <div class="section-head">
                          <div class="mt-separator-outer separator-left">
                              <div class="mt-separator">
                                  <h2 class="text-uppercase sep-line-one "><span class="font-weight-300 text-primary">Formulario</span> de Registro</h2>
                              </div>
                          </div>
                      </div>
                      <!-- TITLE END -->

                          <div class="form-group">
                              <input formControlName="nombre" type="text" required class="form-control" placeholder="Nombres y Apellidos">
                              <div *ngIf="isFieldValid('nombre')"
                                class="alert alert-danger">

                                <div *ngIf="nombre.errors.required">
                                  El Nombre Completo es requerido
                                </div>
                              </div>
                          </div>
                          <div class="form-group">
                            <input formControlName="cedula_identidad" type="text" required class="form-control" placeholder="Cedula de Identidad">
                            <div *ngIf="isFieldValid('cedula_identidad')"
                              class="alert alert-danger">

                              <div *ngIf="cedula_identidad.errors.required">
                                El Cedula de identidad es requerido
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <input formControlName="cargo" type="text" required class="form-control" placeholder="Cargo / Ocupación">
                            <div *ngIf="isFieldValid('cargo')"
                              class="alert alert-danger">

                              <div *ngIf="cargo.errors.required">
                                El Cargo / Ocupación es requerido
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <input formControlName="institucion" type="text" required class="form-control" placeholder="Institución / Organización Social / Empresa">
                            <div *ngIf="isFieldValid('institucion')"
                              class="alert alert-danger">

                              <div *ngIf="institucion.errors.required">
                                El Institución / Organización Social / Empresa es requerido
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <input formControlName="telefono" type="text" required class="form-control" placeholder="Teléfono">
                            <div *ngIf="isFieldValid('telefono')"
                              class="alert alert-danger">

                              <div *ngIf="telefono.errors.required">
                                El Teléfono es requerido
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                              <input formControlName="correo" type="text" class="form-control" required placeholder="Correo Electrónico">
                              <div *ngIf="isFieldValid('correo')"
                                class="alert alert-danger">

                                <div *ngIf="correo.errors.required">
                                  El Correo es requerido
                                </div>
                                <div *ngIf="correo.errors.email">
                                  Debe introducir un correo valido
                                </div>
                              </div>
                          </div>


                          <div>
                            <ngx-recaptcha2 #captchaElem
                              [siteKey]="siteKey"
                              formControlName="recaptcha"
                              >
                            </ngx-recaptcha2>
                            <div *ngIf="isFieldValid('recaptcha')"
                                class="alert alert-danger">

                                <div >
                                  El Captcha es requerido
                                </div>
                              </div>
                          </div>

                        <div class="text-right">
                              <button name="submit" type="submit" value="Submit" class="site-button btn-effect" >Enviar
                              </button>
                          </div>

                      </div>
                  </form>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="m-b30">
                      <!-- TITLE START -->
                      <div class="section-head">
                          <div class="mt-separator-outer separator-left">
                              <div class="mt-separator">
                                  <h2 class="text-uppercase sep-line-one "><span class="font-weight-300 text-primary">Rendición </span>de Cuentas</h2>
                              </div>
                          </div>
                      </div>
                      <!-- TITLE END -->
                      <div class="">
                        <table>
                          <tr><th>Tema:</th><td>{{ evento.titulo }}</td></tr>
                          <tr><th>Descripción:</th><td>{{ evento.descripcion }}</td></tr>
                          <tr><th>Hora:</th><td>{{ evento.horario }}</td></tr>

                        </table>
                        <iframe *ngIf="evento.estado_enlace" allowfullscreen="" frameborder="0" height="500" scrolling="yes" [src]="enlace" style="border:2px solid #ccc" width="100%"></iframe>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="gmap-outline">
          <div id="gmap_canvas2" class="google-map"></div>
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/registro-rendicion/registro-rendicion.component.html